export default {
  install(Vue) {
    Vue.component('Flex1', require('./flex-1').default)
    Vue.component('Jsx', require('./jsx').default)
    Vue.component('Loading', require('./loading').default)
    Vue.component('NoData', require('./no-data').default)
    Vue.component('CmmImage', require('./cmm-image').default)
    Vue.component('CmmNoData', require('./cmm-no-data').default)
  }
}
